import { ApiRequest } from '@/hooks/api';

export interface JournalResponse {
	emotion: string;
	id: string;
	images: Array<{
		id: string;
		url: string;
		emotion?: string;
	}>;
}

export class JournalService {
	private apiRequest: ApiRequest;

	constructor(apiRequest: ApiRequest) {
		this.apiRequest = apiRequest;
	}

	async createJournalEntry(imageDataUrls: string[]): Promise<JournalResponse> {
		// Convert data URLs to Blob objects for multipart upload
		const imageBlobs = imageDataUrls.map((dataUrl, index) => {
			const byteString = atob(dataUrl.split(',')[1]);
			const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];

			const ab = new ArrayBuffer(byteString.length);
			const ia = new Uint8Array(ab);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new File([ab], `image${index + 1}.${mimeString.split('/')[1]}`, {
				type: mimeString,
			});
		});

		// Create FormData for multipart request
		const formData = new FormData();

		// Append each image file
		imageBlobs.forEach(file => {
			formData.append('images', file);
		});

		const response = await this.apiRequest<JournalResponse>({
			endpoint: 'v2/nvision/journal/multipart',
			method: 'POST',
			body: formData,
		});

		return response.data;
	}

	async updateAnnotation(journalId: string, emotion: string): Promise<void> {
		await this.apiRequest({
			endpoint: `v2/nvision/journal/${journalId}`,
			method: 'PUT',
			body: { annotation: emotion },
		});
	}

	async deleteJournalEntry(journalId: string): Promise<void> {
		await this.apiRequest({
			endpoint: `v2/nvision/journal/${journalId}`,
			method: 'DELETE',
		});
	}

	async deleteJournal(): Promise<void> {
		await this.apiRequest({
			endpoint: 'v2/nvision/journal',
			method: 'DELETE',
		});
	}
}
